import { PropertyAmenityType } from "../../../Types/propertyAmenityTypes"
import QuickForm from "../QuickForm/QuickForm"

export default function PropertyAmenityForm(props: {
    disabled: boolean,
    onSubmit: (v: any) => Promise<any>,
    initialValues?: Partial<PropertyAmenityType>,
    propertyOptions?: { value: string, text: string }[],
    amenityOptions?: { value: string, text: string }[],
}) {
    const {
        disabled,
        onSubmit,
        initialValues,
        propertyOptions = [],
        amenityOptions = [],
    } = props

    return (
        <div className="property-amenity-form">
            <QuickForm
                showErrors={true}
                initialData={{
                    propertyId: '',
                    amenityId: '',
                    overrides: {},
                    ...(initialValues ? { ...initialValues } : {}),
                }}
                fields={[
                    {
                        fieldName: 'propertyId',
                        fieldLabel: 'Property',
                        fieldType: 'select',
                        placeholder: '- Select Property -',
                        required: true,
                        options: propertyOptions,
                        layout: { xs: 12, md: 6 },
                    },
                    {
                        fieldName: 'amenityId',
                        fieldLabel: 'Amenity',
                        fieldType: 'select',
                        placeholder: '- Select Amenity -',
                        required: true,
                        options: amenityOptions,
                        layout: { xs: 12, md: 6 },
                    },
                ]}
                disabled={disabled}
                onSubmit={onSubmit}
            />
        </div>
    )
}
